import React, {FunctionComponent} from "react";
import {ParticipantRating, Movement} from "/src/domain/challenges/ChallengeRatingData";
import {Up, InPlace, Down} from "/src/ui/shared/challengeRating/Movement";
import {Grid, Link} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {theme} from "/src/assets/theme";
import cs from 'classnames';
import {parse} from 'query-string';
import {links} from '/src/domain/shared/links';

interface ParticipantRowData {
    participant: ParticipantRating;
    currentUserId?: string;
}

const ParticipantRow: FunctionComponent<ParticipantRowData> = ({
                                                                   participant,
                                                                   currentUserId
                                                               }) => {
    const classes = useStyles();
    const query = parse(location.search);
    const link = query.org
        ? `${links.challengesOrigin}/rating/user?id=${participant.id}&org=${query.org}`
        : `${links.challengesOrigin}/rating/user?id=${participant.id}`;

    return (
        <Grid container
              key={participant.id}
              justifyContent="center"
              alignItems="center"
              className={cs(classes.participant, {[classes.currentUser]: currentUserId === participant.id})}
              spacing={1}
        >
            <Grid item xs={1} className={classes.cell}>{participant.place}</Grid>
            <Grid item container alignItems="center" xs={1} className={classes.cell}>
                {participant.movement === Movement.UP && <Up/>}
                {participant.movement === Movement.IN_PLACE && <InPlace/>}
                {participant.movement === Movement.DOWN && <Down/>}
            </Grid>
            <Grid item xs={5} className={classes.cell}>
                <Link underline="hover" href={link}>
                    {`${participant.firstName} ${participant.lastName}`}
                </Link>
            </Grid>
            <Grid item xs={2} className={classes.clubLogoCell}>
                <img className={classes.clubLogo} src={participant.clubLogoUrl}/>
            </Grid>
            <Grid item container justifyContent="flex-end" xs={2} className={classes.cell}>{participant.rating}</Grid>
        </Grid>
    );
}

const useStyles = makeStyles((muiTheme) => ({
    participant: {
        width: '100%',
        padding: '0.5rem 0',
        margin: '0',
        '&:nth-child(odd)': {
            backgroundColor: theme.lightPrimaryColor
        }
    },
    cell: {
        overflowX: 'auto'
    },
    currentUser: {
        backgroundColor: theme.primaryCurrentUserColor
    },
    clubLogo: {
        maxHeight: '2.5rem',
        maxWidth: '100%'
    },
    clubLogoCell: {
        overflowX: 'auto',
        padding: 0
    }
}))

export default ParticipantRow